import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pers',
  templateUrl: './pers.component.html',
  styleUrls: ['./pers.component.scss']
})
export class PersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
